import { ReactComponent as EstablishmentIcon } from '../assets/icons/resort.svg';
import { ReactComponent as ProductsIcon } from '../assets/icons/products.svg';
import { ReactComponent as AdminIcon } from '../assets/icons/users.svg';

const sidebarMenuEntries = [
  {
    path: '/',
    label: 'sidebarMenu.admin',
    icon: <AdminIcon />,
  },
  {
    path: '/establishment',
    label: 'sidebarMenu.establishment',
    icon: <EstablishmentIcon />,
  },
  {
    path: '/products',
    label: 'sidebarMenu.products',
    icon: <ProductsIcon />,
    subLevels: [
      {
        path: '/products/camps',
        label: 'sidebarMenu.camps',
      },
      {
        path: '/products/extras',
        label: 'sidebarMenu.extras',
      },
      {
        path: '/products/hosting',
        label: 'sidebarMenu.hosting',
      },
    ],
  },
];

export default sidebarMenuEntries;
